export const isArray = (value: any): boolean => Array.isArray(value);

export const isNull = (value: any): boolean => value === null;

export const isUndefined = (value: any): boolean => value === undefined;

export const isEmptyString = (value: any): boolean => value === "";

export const isEmptyArray = (value: any): boolean => isArray(value) && value.length === 0;

export const isString = (value: any): value is string => typeof value === "string";

export const isBoolean = (value: any): value is boolean => typeof value === "boolean";

export const isNumber = (value: any): value is number => typeof value === "number";

export const isRegExp = (value: any): value is RegExp => value instanceof RegExp;
